import { AccountService } from "./../../services/account.service";
import { AlertManagerComponent } from "./../alert-manager/alert-manager.component";
import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { HttpClient } from "@angular/common/http";
import Swal from "sweetalert2";

class Condition {
  Id?: number;
  PropertyName: string;
  Condition: number;
  PropertyValue: string;
}

class CreateAlert {
  Id?: number;
  RelationCode: string;
  SymbolCode: string;
  Conditions: Condition[] = [];
  ExpirationType: number;
  ExpirationDate: Date;
  NotificationType: number;
}

@Component({
  selector: "app-create-alert",
  templateUrl: "./create-alert.component.html",
  styleUrls: ["./create-alert.component.scss"],
})
export class CreateAlertComponent implements OnInit {
  newAlert: CreateAlert = new CreateAlert();
  tempCondition: Condition = new Condition();
  notificationTypes = [
    {
      name: "Web",
      value: 1,
    },
    {
      name: "Mobile",
      value: 2,
    },
    {
      name: "Email",
      value: 3,
    },
    {
      name: "Sms",
      value: 4,
    },
    {
      name: "All",
      value: 5,
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<CreateAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private accService: AccountService,
    private http: HttpClient
  ) {}

  alertManager() {
    this.dialogRef.close();
    this.dialog.open(AlertManagerComponent, { width: "800px" });
  }

  removeAlert(index) {
    this.newAlert.Conditions.splice(index, 1);
  }

  addAlert() {
    this.newAlert.Conditions.push(this.tempCondition);
    this.tempCondition = new Condition();
  }

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  createAlert() {
    Swal.fire({
      position: "center",
      icon: "info",
      title: "COMING SOON",
      showConfirmButton: false,
      timer: 4500,
    });
    // this.newAlert.SymbolCode = this.data.symbol;
    // this.newAlert.RelationCode = "1001-1";

    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     Authorization: this.accService.userValue.toString(),
    //   }),
    // };

    // return this.http
    //   .post(
    //     UrlConstants.backofficeUrl + "/api/OnlineTrading/Subscribe",
    //     this.newAlert,
    //     httpOptions
    //   )
    //   .subscribe((res) => {});
  }
}
